var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data)?_c('div',{staticStyle:{"display":"contents"}},[(_vm.isImage)?[_c('img',{attrs:{"src":`data:${_vm.data.contentType};base64,${_vm.data.content}`,"alt":"QR Code"}})]:(_vm.isText)?[_c('span',{staticClass:"access-code-text"},[_vm._v(_vm._s(_vm.data.content))])]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }